var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgPreparing = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.89727 0.369091L3.18182 0H16.8182L17.1018 0.369091L20 4.23273V19C20 19.5523 19.5523 20 19 20H1C0.447715 20 0 19.5523 0 19V4.23273L2.89727 0.369091ZM9.09091 1.81818H4.09091L2.72727 3.63636H9.09091V1.81818ZM15.9091 1.81818H10.9091V3.63636H17.2727L15.9091 1.81818ZM18.1818 5.45455H1.81818V17.1818C1.81818 17.7341 2.2659 18.1818 2.81818 18.1818H17.1818C17.7341 18.1818 18.1818 17.7341 18.1818 17.1818V5.45455ZM14.3266 9.68251C14.6534 9.30131 14.6092 8.7274 14.228 8.40065C13.8468 8.07389 13.2729 8.11803 12.9462 8.49923L9.34265 12.7032L7.91559 11.2762C7.56057 10.9211 6.98497 10.9211 6.62994 11.2762C6.27492 11.6312 6.27492 12.2068 6.62994 12.5618L8.75116 14.683C8.93021 14.8621 9.17583 14.9583 9.42886 14.9486C9.68189 14.9389 9.91941 14.8241 10.0842 14.6318L14.3266 9.68251Z",
    fill: "#BB6BD9"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPreparing, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/preparing.3b0e9d56.svg";
export { ForwardRef as ReactComponent };